import { takeLatest, put, call } from "redux-saga/effects";
import api from "../../utils/api";
import {
  GET_HISTORY,
  FETCH_HISTORY_DATA
} from "./actions"

function* updateHistory(action) {
    const { payload } = action || {};
    const { type } = payload;
    const action_1 = Object.assign({});
    action_1.handler = "V1_GET_HISTORY";
    action_1.query = { type };
      const response = yield call(api, action_1);
      if (response.status === 200) {
        yield put({ type: "UPDATE_HISTORY", historydata: response.data });
      }
  }
  
function* getHistory() {
  yield takeLatest(GET_HISTORY, updateHistory);
}

function* updateHistoryData(action) {
  const { name,offset,limit } = action;
  yield put({
    type: "UPDATE_HISTORY_DATA",
    name,
    offset,
    limit
  });
}

function* fetchHistoryData() {
yield takeLatest(FETCH_HISTORY_DATA, updateHistoryData);
}
//------------------------------------------------------------------------------------------------------

export default [
  getHistory,
  fetchHistoryData
];


// WEBPACK FOOTER //
// ./src/shells/HistoryLeaderboard/sagas.js